import { render, staticRenderFns } from "./AllPartnerPointBalance.vue?vue&type=template&id=cd1b37d8&scoped=true"
import script from "./AllPartnerPointBalance.vue?vue&type=script&lang=js"
export * from "./AllPartnerPointBalance.vue?vue&type=script&lang=js"
import style0 from "./AllPartnerPointBalance.vue?vue&type=style&index=0&id=cd1b37d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1b37d8",
  null
  
)

export default component.exports